import PropTypes from 'prop-types';
import { FaMinusCircle } from 'react-icons/fa';

const RemoveButton = ({ onClick }) => <FaMinusCircle color="#2173AE" onClick={onClick} />;

RemoveButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default RemoveButton;
